import React from 'react';
import PropTypes from 'prop-types';
import {RenderTubeImage} from '@learningblocks/storybook-components';

/**
 * TestTubeImage:
 *  - Render TestTube Image and serve as a wrapper for Image and Dropdown
 */
export function TestTubeImage({tubeType, children}) {
  return (
    <div className={`option-content-${tubeType}`}>
      <RenderTubeImage type={tubeType} />
      {children}
    </div>
  );
}

TestTubeImage.propTypes = {
  /**
   * Type of tube to be rendered
   */
  tubeType: PropTypes.oneOf(['TUBE', 'GLASS_TUBE']),
  /**
   * The Dropdown to be displayed on TestTube
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
